import { HttpClient } from '@angular/common/http';
import { IModuleTranslationOptions, ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { environment } from '@environments/environment';
export function HttpLoaderFactory(http: HttpClient) {
    const translationAPI = environment.identityAPI;
    const baseTranslateUrl = `${translationAPI}/api/translation/`;

    const options: IModuleTranslationOptions = {
        //version: Date.now(),
        translateError: (error, path) => {
            console.log('translation loader: an error occurred: ', { error, path });
        },
        modules: [
            { baseTranslateUrl, pathTemplate: `{baseTranslateUrl}/{moduleName}?lang={language}`, moduleName: 'COMMON' },
            { baseTranslateUrl, pathTemplate: `{baseTranslateUrl}/{moduleName}?lang={language}`, moduleName: 'COMPONENTS' },
            { baseTranslateUrl, pathTemplate: `{baseTranslateUrl}/{moduleName}?lang={language}`, moduleName: 'ACCESSIBILITY' },
            { baseTranslateUrl, pathTemplate: `{baseTranslateUrl}/{moduleName}?lang={language}`, moduleName: 'LANGUAGES_OPTIONS' },
            { baseTranslateUrl, pathTemplate: `{baseTranslateUrl}/{moduleName}?lang={language}`, moduleName: 'LANDPAGE' },
        ],
        disableNamespace: true
    };
    return new ModuleTranslateLoader(http, options);
}
